import { render } from "./Expired-product.vue?vue&type=template&id=2c1d0040&scoped=true"
import script from "./Expired-product.vue?vue&type=script&lang=js"
export * from "./Expired-product.vue?vue&type=script&lang=js"

import "./Expired-product.vue?vue&type=style&index=0&id=2c1d0040&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1d0040"]])

export default __exports__